"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _isBasketPage = require("./isBasketPage");
Object.keys(_isBasketPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isBasketPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isBasketPage[key];
    }
  });
});
var _isMinibagVisibile = require("./isMinibagVisibile");
Object.keys(_isMinibagVisibile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isMinibagVisibile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isMinibagVisibile[key];
    }
  });
});
var _getTranslationsProps = require("./getTranslationsProps");
Object.keys(_getTranslationsProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTranslationsProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTranslationsProps[key];
    }
  });
});
